import { GetGiftCardDetailsErrorCodeV1, GetGiftCardDetailsErrorV1 } from '@vista-digital/ocapi-client';
import { runInAction } from 'mobx';
import { ocapiClient } from '../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../types/errors/common-error-codes';
import { GiftCardDomainError, GiftCardDomainSpecificErrorCode } from '../errors/gift-card-domain-error';
import { temporaryGiftCardDomainStore } from '../store';
export const loadGiftCardDetails = async (giftCardCredentials, captchaResponse) => {
    let response;
    try {
        response = await ocapiClient.instance.v1.giftCards.getDetails(giftCardCredentials, captchaResponse);
    }
    catch (error) {
        if (error instanceof GetGiftCardDetailsErrorV1) {
            const errorCode = convertApiToDomainErrorCode(error.errorCode);
            throw new GiftCardDomainError(errorCode, error.message);
        }
        throw error;
    }
    runInAction(() => {
        temporaryGiftCardDomainStore.data.giftCardDetails = response;
    });
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case GetGiftCardDetailsErrorCodeV1.InvalidCardNumberOrPin:
            return GiftCardDomainSpecificErrorCode.GiftCardCredentialsInvalid;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
